exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ndiv[data-v-c6283c82] {\n    background-color: #0758F3;\n    width: 5px;\n    height: 5px;\n    border-radius: 5px;\n}\n", ""]);

